import React from 'react';
import Button from '../../../components/ui/Button';

const QuickActions = ({ userRole, onCreatePermit, onViewAnalytics, onManageUsers }) => {
  const actions = [
    {
      label: 'Create Work Permit',
      icon: 'FilePlus',
      variant: 'default',
      onClick: onCreatePermit,
      roles: ['Safety Manager', 'Operations Supervisor']
    },
    {
      label: 'View Analytics',
      icon: 'BarChart3',
      variant: 'outline',
      onClick: onViewAnalytics,
      roles: ['Safety Manager', 'Compliance Officer']
    },
    {
      label: 'Manage Users',
      icon: 'Users',
      variant: 'outline',
      onClick: onManageUsers,
      roles: ['Safety Manager']
    }
  ];

  const availableActions = actions?.filter(action => action?.roles?.includes(userRole));

  if (availableActions?.length === 0) return null;

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <h2 className="text-xl font-semibold text-foreground mb-4">Quick Actions</h2>
      <div className="flex flex-wrap gap-3">
        {availableActions?.map((action, index) => (
          <Button
            key={index}
            variant={action?.variant}
            iconName={action?.icon}
            iconPosition="left"
            onClick={action?.onClick}
          >
            {action?.label}
          </Button>
        ))}
      </div>
    </div>
  );
};

export default QuickActions;